<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <mat-spinner *ngIf="!contest" color="primary" diameter="40"></mat-spinner>
        <div *ngIf="contest" class="contest-title">{{contest.name}}</div>

        <div class="fill-space"></div>

        <app-button *ngIf="editMode || localizeMode"
                    label="Cancel"
                    i18n-label="General|Cancel action label@@general-cancel-action-label"
                    [secondary]="true"
                    [disabled]="inProgress"
                    (clicked)="cancelEdit()"></app-button>

        <div class="btn-spacer"></div>

        <app-button
          *ngIf="!editMode && !localizeMode && taskGrade && taskType && taskLocale && taskTypeAvailable && !taskLocaleAvailable"
          label="Translate"
          i18n-label="General|Translate action label@@general-translate-action-label"
          color="primary"
          [disabled]="inProgress || !contestEditAllowed"
          (clicked)="localizeTask(taskGrade, taskType, taskLocale)"></app-button>

        <app-button
          *ngIf="!editMode && !localizeMode && taskGrade && taskType && taskLocale && taskLocaleAvailable"
          label="Edit"
          i18n-label="General|Edit action label@@general-edit-action-label"
          color="primary"
          [disabled]="inProgress || !contestEditAllowed"
          (clicked)="editTask(taskGrade, taskType, taskLocale)"
          [multiAction]="true"
          [actions]="ctaActions"
          (actionClicked)="ctaActionSelected($event)"></app-button>

        <app-button
          *ngIf="!editMode && !localizeMode && taskGrade && taskType && taskLocale && !taskTypeAvailable"
          label="Create"
          i18n-label="General|Create action label@@general-create-action-label"
          color="primary"
          [disabled]="inProgress || !contestEditAllowed"
          (clicked)="createTask(taskGrade, taskType, taskLocale)"></app-button>
        <app-button *ngIf="editMode || localizeMode"
                    label="Save"
                    i18n-label="General|Save action label@@general-save-action-label"
                    color="primary"
                    [disabled]="inProgress || (editMode && !canProceedWithSave)"
                    (clicked)="saveTask()"></app-button>
      </mat-toolbar-row>

      <mat-toolbar-row fxLayout="row" class="mat-body">
        <item-select fxFlex="32%"
                     [roles]="roles"
                     label="Task Grade:"
                     i18n-label="Contest Tasks Editor|Contest task grade input label@@contest-tasks-editor-task-grade-input-label"
                     [compareWith]="compareTaskGrades"
                     [displayWith]="displayTaskGrade"
                     [loadWith]="loadTaskGrades"
                     [selectedItem]="taskGrade"
                     [disabled]="inProgress || editMode || localizeMode"
                     (selected)="changeTaskGrade($event)"></item-select>
        <div class="fill-space"></div>
        <item-select fxFlex="32%"
                     [roles]="roles"
                     label="Task Type:"
                     i18n-label="Contest Tasks Editor|Contest task type input label@@contest-tasks-editor-task-type-input-label"
                     [compareWith]="compareTaskTypes"
                     [displayWith]="displayTaskType"
                     [loadWith]="loadTaskTypes"
                     [selectedItem]="taskType"
                     [disabled]="inProgress || editMode || localizeMode"
                     (selected)="changeTaskType($event)"></item-select>
        <div class="fill-space"></div>
        <item-select fxFlex="32%"
                     [roles]="roles"
                     label="Task Locale:"
                     i18n-label="Contest Tasks Editor|Contest task locale input label@@contest-tasks-editor-task-locale-input-label"
                     [compareWith]="compareTaskLocales"
                     [displayWith]="displayTaskLocale"
                     [loadWith]="loadTaskLocales"
                     [selectedItem]="taskLocale"
                     [disabled]="inProgress || editMode || localizeMode"
                     (selected)="changeTaskLocale($event)"></item-select>
      </mat-toolbar-row>
    </mat-toolbar>

    <app-no-content *ngIf="!inProgress && !contest"
                    title="Contest was not found"
                    i18n-title="Contest Details|Contest not found title@@contest-details-not-found-title"
                    details="Please select a correct contest from the list first"
                    i18n-details="Contest Details|Contest not found details@@contest-details-not-found-details"></app-no-content>
    <app-no-content *ngIf="!inProgress && (!taskGrade || !taskType || !taskLocale)"
                    title="Contest tasks are created for a grade with a type in a locale"
                    i18n-title="Contest Tasks Editor|Select grade, type and locale title@@contest-tasks-editor-select-grade-type-locale-title"
                    details="Please select grade, task type and locale first"
                    i18n-details="Contest Tasks Editor|Select grade, type and locale details@@contest-tasks-editor-select-grade-type-locale-details"></app-no-content>

    <app-no-content
      *ngIf="!inProgress && !editMode && !localizeMode && taskGrade && taskType && taskLocale && !taskTypeAvailable"
      title="No task was found for selected type and locale"
      i18n-title="Contest Tasks Editor|No task for type and locale title@@contest-tasks-editor-no-task-for-type-and-locale-title"
      details="You can start by creating one"
      i18n-details="Contest Tasks Editor|No task for type and locale details@@contest-tasks-editor-no-task-for-type-and-locale-details">
      <app-button *ngIf="contestEditAllowed"
                  label="Create"
                  i18n-label="General|Create action label@@general-create-action-label"
                  color="primary"
                  class="no-content-cta"
                  [disabled]="inProgress"
                  (clicked)="createTask(taskGrade, taskType, taskLocale)"></app-button>
    </app-no-content>
    <app-no-content
      *ngIf="!editMode && !localizeMode && taskGrade && taskType && taskLocale && taskTypeAvailable && !taskLocaleAvailable"
      title="No task was found for selected locale with type"
      i18n-title="Contest Tasks Editor|No task for locale with type title@@contest-tasks-editor-no-task-for-locale-with-type-title"
      details="You can translate task into selected language"
      i18n-details="Contest Tasks Editor|No task for locale with type details@@contest-tasks-editor-no-task-for-locale-with-type-details">
      <app-button *ngIf="contestEditAllowed"
                  label="Translate"
                  i18n-label="General|Translate action label@@general-translate-action-label"
                  color="primary"
                  class="no-content-cta"
                  [disabled]="inProgress"
                  (clicked)="localizeTask(taskGrade, taskType, taskLocale)"></app-button>
    </app-no-content>

    <div class="content page extra-toolbar">
      <mat-spinner *ngIf="inProgress" [diameter]="40" class="center-middle" color="primary"></mat-spinner>

      <div *ngIf="!inProgress && task && taskLocale" class="editor-holder" fxLayout="column">
        <contest-editor-section *ngFor="let section of task.sections[taskLocale]"
                                fxFlex="100%"
                                class="section full-width"
                                [section]="section"
                                [editAllowed]="editMode"
                                [localizeAllowed]="localizeMode"
                                [disabled]="!editMode || !localizeMode"
                                (delete)="deleteSection($event)"
                                (sectionUpdated)="handleSectionUpdate($event)"></contest-editor-section>

        <div *ngIf="editMode" class="add-section-container">
          <mat-error *ngIf="task.sections[taskLocale].length == 0"
                     i18n="Contest Tasks Editor|Task not enough sections error@@contest-tasks-editor-task-not-enough-sections-error">
            Contest task should contain at least 1 section
          </mat-error>

          <app-button *ngIf="editMode"
                      color="primary"
                      class="add-section-btn"
                      label="Add Section"
                      i18n-label="Contest Tasks Editor|Add section btn title@@contest-tasks-editor-add-section-btn-title"
                      (clicked)="addSection()"></app-button>
        </div>
      </div>
    </div>
  </div>
</permission-checker>
